import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';

const useActionDialogStyles = makeStyles(theme => ({
    dialogBox: {
        minWidth: theme.spacing(65),
        minHeight: theme.spacing(7),
        maxWidth: 'unset',
    },
}));

const ActionDialogComponent = (props: any) => {

    let dialog = props;
    let defaultAction = dialog.defaultAction ? dialog.defaultAction : 'Cancel';
    const classes = useActionDialogStyles();

  return (
      <Dialog
        open={dialog.open}
        onClose={()=>dialog.handleClose(defaultAction)}
        aria-labelledby={dialog.title}
        classes={{
            paper: classes.dialogBox
        }}
      >
        <DialogTitle id={dialog.title}>{dialog.title}</DialogTitle>
        <DialogContent>
          <DialogContentText component='div'>
            {dialog.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
            {dialog.children}
        </DialogActions>
      </Dialog>
  );
}
export default ActionDialogComponent

// eslint-disable-next-line
{/* <ActionDialogComponent message="cancel" title="title" open={open} handleClose={handleClose} defaultAction="Cancel">
        <Button onclick={handleClose} color='primary'> {action} </Button>
    </ActionDialogComponent> 
*/}